import { render, staticRenderFns } from "./ObjectDetectionExportAsBtn.vue?vue&type=template&id=ce806a48"
import script from "./ObjectDetectionExportAsBtn.vue?vue&type=script&lang=js"
export * from "./ObjectDetectionExportAsBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports